import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const getSiteVisitList = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_SITE_VISIT_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/site-visit/list`,
        formData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_SITE_VISIT_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_SITE_VISIT_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_SITE_VISIT_LIST_FAILED", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const getAgentSiteVisitList = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_AGENT_SITE_VISIT_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/site-visit/list`,
        formData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_AGENT_SITE_VISIT_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_AGENT_SITE_VISIT_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_AGENT_SITE_VISIT_LIST_FAILED", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const viewSiteVisit = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_SITE_VISIT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(`${BASE_URL}/site-visit/view/${id}`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "GET_SITE_VISIT_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_SITE_VISIT_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_SITE_VISIT_FAIL", payload: error.message });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addSiteVisitRental = (formData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_SITE_VISIT_RENTAL_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/site-visit-rental/add`,
        formData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_SITE_VISIT_RENTAL_SUCCESS", payload: data });
      } else {
        dispatch({ type: "ADD_SITE_VISIT_RENTAL_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "ADD_SITE_VISIT_RENTAL_FAIL", payload: error.message });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const statusSiteVisitRental = (formData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "STATUS_SITE_VISIT_RENTAL_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/site-visit-rental/update-status`,
        formData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "STATUS_SITE_VISIT_RENTAL_SUCCESS", payload: data });
      } else {
        dispatch({ type: "STATUS_SITE_VISIT_RENTAL_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "STATUS_SITE_VISIT_RENTAL_FAIL", payload: error.message });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewSiteVisitRental = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_SITE_VISIT_RENTAL_REQUEST" });

      const { data } = await axios.get(
        `${BASE_URL}/site-visit-rental/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_SITE_VISIT_RENTAL_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VIEW_SITE_VISIT_RENTAL_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "VIEW_SITE_VISIT_RENTAL_FAIL", payload: error.message });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const listSiteVisitRental = (formData, showLoader = true) => {
  return async (dispatch) => {
    if (showLoader) dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "LIST_SITE_VISIT_RENTAL_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/site-visit-rental/list`,
        formData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_SITE_VISIT_RENTAL_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_SITE_VISIT_RENTAL_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "LIST_SITE_VISIT_RENTAL_FAIL", payload: error.message });
    } finally {
      if (showLoader) dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getFranchiseSiteVisitList = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_FRANCHISE_SITE_VISIT_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/site-visit/franchise-list`,
        formData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_FRANCHISE_SITE_VISIT_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_FRANCHISE_SITE_VISIT_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_FRANCHISE_SITE_VISIT_LIST_FAILED", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const resetSiteVisitRental = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_SITE_VISIT_RENTAL" });
  };
};